<template>
  <Fieldset class="w-11" :toggleable="true" :collapsed="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="font-medium">Datos de contacto</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">País de residencia</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.countryResidence }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Ciudad</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.cityResidence
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Dirección domiciliar</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.addressLocation }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Teléfono primario</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.primaryPhone
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Teléfono secundario</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.secondaryPhone
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Código postal</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.postalCode
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
    </div>
  </Fieldset>
</template>

<script setup lang="ts">
  import { toRefs } from 'vue'
  import type { EmployeeDetail } from '@/modules/employees/models/EmployeeDetail'

  const props = defineProps<{
    employee?: EmployeeDetail
  }>()

  const { employee } = toRefs(props)
</script>
